<template>
<div class="root-wide">
  <router-view />
</div>

</template>

<script>
import './Layout.scss';
export default {
  name: 'Layout',

};
</script>

<style src="./LayoutWide.scss" lang="scss" />
